module.exports = __webpack_public_path__ + "static/media/bg12.17157e17.jpg";